import { lazy, Suspense } from 'react'
import SEOHead from '@/components/SEOHead'
import Navbar from '@/components/Navbar'
import Hero from '@/components/Hero'

// Lazy-load heavier interactive modules for faster initial paint
const SleepCycleCalculator = lazy(() => import('@/components/SleepCycleCalculator'))
const NapPlanner = lazy(() => import('@/components/NapPlanner'))
const SleepDebtTracker = lazy(() => import('@/components/SleepDebtTracker'))
const StopBangCalculator = lazy(() => import('@/components/StopBangCalculator'))
const ESSCalculator = lazy(() => import('@/components/ESSCalculator'))
const CPAPCalculator = lazy(() => import('@/components/CPAPCalculator'))
const JetLagCalculator = lazy(() => import('@/components/JetLagCalculator'))
const MonetizationHub = lazy(() => import('@/components/MonetizationHub'))
const FAQSection = lazy(() => import('@/components/FAQSection'))
const Footer = lazy(() => import('@/components/Footer'))

function SectionFallback() {
  return (
    <div className="py-20 flex items-center justify-center" aria-hidden="true">
      <div className="w-8 h-8 rounded-full border-2 border-indigo-500/30 border-t-indigo-400 animate-spin" />
    </div>
  )
}

function Divider() {
  return (
    <div className="max-w-5xl mx-auto px-4">
      <div className="section-divider" />
    </div>
  )
}

export default function Home() {
  return (
    <div className="min-h-screen bg-[#080c14] text-slate-200 overflow-x-hidden">
      <SEOHead />
      <Navbar />

      <main>
        <Hero />

        <Suspense fallback={<SectionFallback />}>
          <SleepCycleCalculator />
          <Divider />
          <NapPlanner />
          <Divider />
          <SleepDebtTracker />
          <Divider />
          <StopBangCalculator />
          <Divider />
          <ESSCalculator />
          <Divider />
          <CPAPCalculator />
          <Divider />
          <JetLagCalculator />
          <Divider />
          <MonetizationHub />
          <Divider />
          <FAQSection />
          <Footer />
        </Suspense>
      </main>
    </div>
  )
}
